import { useMemo } from 'react';
import { Order } from '../types';

/**
 * Custom hook to calculate summary values from orders
 */
export function useTransactionSummary(orders: Order[]) {
  const totalAmount = useMemo(() => 
    orders.reduce((sum, order) => sum + order.totalAmount, 0), 
  [orders]);
  
  const totalCommission = useMemo(() => 
    orders.reduce((sum, order) => sum + order.commission, 0), 
  [orders]);
  
  const totalNetEarnings = useMemo(() => 
    orders.reduce((sum, order) => sum + order.netEarnings, 0), 
  [orders]);
  
  return { totalAmount, totalCommission, totalNetEarnings };
}
